function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\uADF8\\uB8F9_1738",
  "data-name": "\\uADF8\\uB8F9 1738",
  transform: "translate(-973.966 -609.986)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "\\uC0AC\\uAC01\\uD615_1306",
  "data-name": "\\uC0AC\\uAC01\\uD615 1306",
  width: 25.651,
  height: 25.651,
  rx: 5,
  transform: "translate(973.966 609.986)",
  fill: "#777"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_484",
  "data-name": "\\uD328\\uC2A4 484",
  d: "M18.506,12.445a5.26,5.26,0,1,1-4.431-4.431A5.26,5.26,0,0,1,18.506,12.445Z",
  transform: "translate(973.488 609.596)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("line", {
  id: "\\uC120_107",
  "data-name": "\\uC120 107",
  x2: 0.013,
  transform: "translate(993.846 615.758)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  id: "\\uD0C0\\uC6D0_39",
  "data-name": "\\uD0C0\\uC6D0 39",
  cx: 1.924,
  cy: 1.924,
  r: 1.924,
  transform: "translate(992.563 613.192)",
  fill: "#fff"
}));

function SvgArtistInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.651,
    height: 25.651,
    viewBox: "0 0 25.651 25.651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtistInstagram);
export default __webpack_public_path__ + "static/media/artist-instagram.e0ee2f7c.svg";
export { ForwardRef as ReactComponent };